import { FormInput, FormState, IntegerType, Labeled } from 'component_utils/FormUtils';
import { getVoiceForId, tts, useConsistentState, useLocalStorage, useRerender } from 'component_utils/utils';
import If from 'components/If';
import Scanner from 'components/Scanner';
import SimpleModal from 'components/SimpleModal';
import React, { useEffect } from 'react';
import { FaTrash } from 'react-icons/fa';
import { Button, Label, Progress, Table } from 'reactstrap';
import * as immutable from 'object-path-immutable';
import { sample } from 'lodash';
import VictorySfx from 'audio/victory1.mp3';
import Nice from 'audio/serialSound.mp3';
import Wrong from 'audio/alarm.mp3';
import { useDeviceConfig } from 'utils/API';

const victorySfx = new Audio(VictorySfx);
const nice = new Audio(Nice);
const wrong = new Audio(Wrong);

export default () => {
  const deviceConfig = useDeviceConfig().deviceConfig
  const [config, setConfig] = useLocalStorage('reaction-speed-game-config', {
    targets: ['A', 'B', 'C', 'D', 'E', 'F'],
    numOfScans: 20,
  })

  const [state, , setState] = useConsistentState({ correct: 0, wrong: 0, scans: 0, startTime: 0, finishTime: 0, target: '', state: 'start' })
  const rerender = useRerender()
  
  useEffect(() => {
    if (state.state === 'playing' && state.target) {
      tts(getVoiceForId(deviceConfig.TTSVoice), state.target.toLowerCase(), deviceConfig.TTSRate);
    }
  }, [deviceConfig.TTSRate, deviceConfig.TTSVoice, state.state, state.scans, state.target])

  useEffect(() => {
    if (state.state !== 'playing') {
      return
    }

    const iv = setInterval(() => {
      rerender();
    }, 100)
    return () => {
      clearInterval(iv)
    }
  })

  return (
    <div className='flex-container'>
      <If cond={state.state === 'start'}>
        <div className='nested-flex-container justify-content-center'>
          <Button color='primary' className='py-5' onClick={() => {
            setState({
              correct: 0,
              wrong: 0,
              scans: 0,
              startTime: Date.now(),
              finishTime: 0,
              target: sample(config.targets),
              state: 'playing',
            })
          }}>
            Play
          </Button>
          <br/>
          <SimpleModal
            title={'Settings'}
            trigger={open => (
              <Button onClick={open} className='py-5'>
                Settings
              </Button>
            )}
          >
            <FormState state={config} setState={setConfig}>
              <Labeled title="Number of scans">
                <FormInput path='numOfScans' typed={IntegerType}/>
              </Labeled>
              <br/>
              
              <Label>Targets</Label>
              <Table striped>
                <tbody>
                  {config.targets.map((target, targetIdx) => (
                    <tr key={targetIdx}>
                      <td>
                        <FormInput path={"targets."+targetIdx}/>
                      </td>
                      <td className='w-0'>
                        <Button color='danger' onClick={() => {
                          setConfig(old => immutable.del(old, "targets."+targetIdx))
                        }}>
                          <FaTrash/>
                        </Button>
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan={2}>
                      <Button block color='primary' onClick={() => {
                        setConfig(old => immutable.push(old, "targets", ''))
                      }}>
                        Add
                      </Button>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </FormState>
          </SimpleModal>
        </div>
      </If>
      <If cond={state.state === 'playing'}>
        <Scanner
          placeholder='Scan target'
          onEnter={s => {
            setState(old => {
              const n = {
                ...old,
              }

              // update the score
              n.scans += 1
              if (old.target === s) {
                n.correct += 1
              } else {
                n.wrong += 1
              }

              // choose a new target (prevent picking the same as last time)
              n.target = sample(config.targets.filter(it => it !== old.target))

              // game finished
              if (n.scans === config.numOfScans) {
                n.finishTime = Date.now()
                n.state = 'result';

                // play the victory sound
                const audio = victorySfx.cloneNode() as HTMLAudioElement
                audio.play()
              } else if (old.target === s) {
                // play normal sound
                const audio = nice.cloneNode() as HTMLAudioElement
                audio.volume = 0.5
                audio.play()
              } else {
                // play error sound
                const audio = wrong.cloneNode() as HTMLAudioElement
                audio.volume = 0.5
                audio.play()
              }
              return n 
            })
          }}
        />
        <Progress min={0} max={config.numOfScans} value={state.scans} color='success' animated>{state.scans} / {config.numOfScans}</Progress>

        <div className='nested-flex-container' style={{
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '80vw',
          overflow: 'hidden',
        }}>
          {state.target}
        </div>

        <div>
          Total time: {((Date.now() - state.startTime) / 1000).toFixed(2)} seconds<br/>
          <span role="img" aria-label="correct">✅</span> {state.correct}<br/>
          <span role="img" aria-label="wrong">❌</span> {state.wrong}
        </div>
      </If>
      <If cond={state.state === 'result'}>
        <div className='nested-flex-container justify-content-center align-items-center'>
          <div className='animated bounceIn'>
            Total time: {((state.finishTime - state.startTime) / 1000).toFixed(2)} seconds<br/>
            <span role="img" aria-label="correct">✅</span> {state.correct}<br/>
            <span role="img" aria-label="wrong">❌</span> {state.wrong}
            <br/>
            <br/>
            <br/>
            <Button block onClick={() => {
              setState(old => ({ ...old, state: 'start' }))
            }}>
              Clear results
            </Button>
          </div>
        </div>
      </If>
    </div>
  )
}